<template>
  <div class="content">
    <div class="layout">
      <div class="user_box" v-if="userShow">
        <div class="user" @click="selectUserA">我是用户A</div>
        <div class="user" @click="selectUserB">我是用户B</div>
      </div>
      <div class="show_user">{{ selfUser }}</div>
      <div class="btn_box">
        <div class="btn_caller">
          <div class="btn_call" @click="startCall">call</div>
        </div>
      </div>
    </div>
    <van-popup v-model:show="loading" round :style="{ width: '100%', height: '100%' }">
      <div class="infer_box" @click.stop.prevent="() => { }">
        <div class="loading_box">
          <div class="loading_item loading7"></div>
          <div class="loading_item loading6"></div>
          <div class="loading_item loading5"></div>
          <div class="loading_item loading4"></div>
          <div class="loading_item loading3"></div>
          <div class="loading_item loading2"></div>
          <div class="loading_item loading1"></div>
          <div class="from_user">{{ fromUserInfo }}</div>
          <div class="times_box">
            <audio id="remoteAudio" ref="audioElement" autoplay></audio>
          </div>
        </div>
        <div class="btn_cancel" v-if="cancelCall" @click="cancel">cancel</div>
        <div class="btn_cancel" v-if="endCall" @click="end">end</div>
        <div class="btn_called" v-if="beCalled">
          <div class="btn_reject" @click="reject">reject</div>
          <div class="btn_accept" @click="accept">accept</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Popup } from 'vant';
export default {
  components: {
    [Popup.name]: Popup,
  },
  data() {
    return {
      timer: null,
      websocket: null,
      userId: null,
      toUserId: null,
      audioContext: null,
      peerConnection: null,
      workletNode: null,
      localStream: null,
      processor: null,
      configuration: {
        iceServers: [{
          urls: 'stun:stun.l.google.com:19302'
        }]
      },
      userShow: true,
      loading: false,
      times: 0,
      caller: false, // 是否是呼叫方，默认时false，点击发起通话后为true，取消后恢复为false
      called: false, // 是否是被呼叫方，目前没有应用在逻辑中
      cancelCall: false, // 取消通话按钮  发起者时显示
      endCall: false, // 结束通话按钮 被呼叫时成功通话显示
      beCalled: true, // 被呼叫显示的按钮
      selfUser: "", // 显示自己
      fromUserInfo: "", // 显示呼叫者,
      remoteAudio: null,
    }
  },
  // 在created中进行数据获取和初始化
  created() {
    // axios.get('/api/data').then(response => {
    //   this.someData = response.data;
    //   this.$nextTick(() => {
    //     // DOM现在已更新，可以进行DOM操作基于someData
    //   });
    // });
  },
  // 在mounted中进行DOM相关的操作。
  mounted() {

  },
  updated() {

  },
  methods: {
    initWebSocket() {
      this.websocket = new WebSocket(`wss://www.catupup.com/wss`);

      this.websocket.onopen = () => {
        console.log('WebSocket 已连接');
        //注册，绑定通道
        let bindData = JSON.stringify({
          cmd: 996,
          os: "weapp",
          appName: "voice",
          userId: this.userId
        });
        this.sendMsg(bindData);

        //心跳
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          this.sendMsg("{cmd: 1}");
        }, 10000)

      }

      this.websocket.onmessage = (res) => {
        if (res.data instanceof ArrayBuffer) {
          // this.playChatAudio(res.data);
          return;
        }
        let data = JSON.parse(res.data);

        if (data.data && data.data.cmd == 66) {
          // 单独处理语音通话收到的消息
          this.handlerMsg(data.data);
        }
      }

      this.websocket.onclose = () => {
        console.log('WebSocket 已关闭');
      };
    },
    sendMsg(msg) {
      this.websocket.send(msg)
    },
    playAudio(name) {
      let src = `${location.protocol}//${location.host}/audio/${name}.mp3`
      let audio = new Audio(src);
      // if (loop) audio.loop = true;
      audio.play();
    },
    handlerMsg(data) {
      let msgType = data.msgType;
      if (this.caller) { // 呼叫方需要处理的消息类型
        // offline accept  cancel  reject end
        switch (msgType) {
          case "offline": // 对方离线
            this.handleOffline();
            break;
          case "accept": // 对方接受
            this.handleAccept();
            break;
          case "answer": // 对方响应
            this.handleAnswer(data.msgData); // sdp和candidate数据都在msgData中
            break;
          case "candidate": // 对方的candidate
            this.handleIceCandidate(data.msgData); // sdp和candidate数据都在msgData中
            break;
          case "reject": // 对方拒绝
            this.handleReject();
            break;
          case "end": // 对方拒绝
            this.handleEnd();
            break;
          default:
            break;
        }
      } else { // 被呼叫方
        // start offer candidate cancel end
        switch (msgType) {
          case "start":
            this.handleStart(data);
            break;
          case "offer": // 收到通话请求,页面显示接受和取消按钮
            this.handleOffer(data.msgData); // sdp和candidate数据都在msgData中
            break;
          case "candidate":
            this.handleIceCandidate(data.msgData); // sdp和candidate数据都在msgData中
            break;
          case "cancel": // 对方取消通话
            this.handleCancel();
            break;
          case "end": // 对方结束通话
            this.handleEnd();
            break;
          default:
            break;
        }
      }
    },
    selectUserA() {
      this.selfUser = "我是用户A";
      this.userShow = false;
      this.userId = 100000000;
      this.toUserId = 100000001;
      this.initWebSocket();
    },
    selectUserB() {
      this.selfUser = "我是用户B";
      this.userShow = false;
      this.userId = 100000001;
      this.toUserId = 100000000;
      this.initWebSocket();
    },
    async startCall() {
      this.caller = true;
      this.called = false;

      this.beCalled = false;
      this.loading = true;
      this.fromUserInfo = `呼叫${this.toUserId}`;

      // 显示取消按钮
      this.cancelCall = true;
      // 隐藏结束按钮
      this.endCall = false;

      let data = JSON.stringify({
        cmd: 66,
        appName: "voice",
        roomId: 1001,
        msgType: "start",
        fromUserId: this.userId,
        toUserId: this.toUserId
      });
      this.sendMsg(data);
    },
    cancel() {
      this.loading = false;
      this.caller = false;
      this.called = false;
      this.endPeerCall();
      let data = JSON.stringify({
        cmd: 66,
        appName: "voice",
        roomId: 1001,
        msgType: "cancel",
        fromUserId: this.userId,
        toUserId: this.toUserId
      });
      this.sendMsg(data);
    },
    accept() {
      this.fromUserInfo = `与${this.toUserId}通话中`;

      this.caller = false;

      // 取消按钮
      this.cancelCall = false;
      // 结束按钮
      this.endCall = true;
      // 接受和拒绝按钮
      this.beCalled = false;

      let data = JSON.stringify({
        cmd: 66,
        appName: "voice",
        roomId: 1001,
        msgType: "accept",
        userId: this.userId,
        toUserId: this.toUserId
      });
      this.sendMsg(data);
    },
    reject() {
      this.loading = false;
      this.called = false;
      let data = JSON.stringify({
        cmd: 66,
        appName: "voice",
        roomId: 1001,
        msgType: "reject",
        userId: this.userId,
        toUserId: this.toUserId
      });
      this.sendMsg(data);
    },
    end() {
      this.loading = false;
      this.called = false;

      this.endPeerCall();
      let data = JSON.stringify({
        cmd: 66,
        appName: "voice",
        roomId: 1001,
        msgType: "end",
        userId: this.userId,
        toUserId: this.toUserId
      });
      this.sendMsg(data);
    },
    handleOffline() {
      this.caller = false;
      this.called = false;
      this.fromUserInfo = "对方离线";
      this.playAudio('cancel');
      setTimeout(() => {
        this.loading = false;
      }, 1500);
      this.endPeerCall();
    },
    async handleAccept() {
      // 取消按钮
      this.cancelCall = false;
      // 结束按钮
      this.endCall = true;

      this.fromUserInfo = `与${this.toUserId}通话中`;
      this.playAudio('accept');
      // 创建offer 发送sdp
      try {
        // 2. 获取用户媒体设备
        this.localStream = await this.getUserMedia();

        // 3. 创建RTCPeerConnection
        this.createPeerConnection();

        // 4. 添加本地流
        this.addLocalStream();

        // 5. 创建并发送offer
        await this.createAndSendOffer();

      } catch (error) {
        console.error('启动通话失败:', error.message);
      }
    },
    async handleAnswer(sdp) {
      await this.peerConnection.setRemoteDescription(
        new RTCSessionDescription({
          type: 'answer',
          sdp: sdp
        })
      );
      // webrtc 发起 candidate
    },
    handleReject() {
      this.caller = false;
      this.called = false;
      this.fromUserInfo = "对方拒绝通话";
      this.playAudio('cancel')
      setTimeout(() => {
        this.loading = false;
      }, 1500)
    },
    handleEnd() {
      this.caller = false;
      this.called = false;
      this.fromUserInfo = "对方结束通话";
      this.playAudio('cancel');

      this.endPeerCall();
      setTimeout(() => {
        this.loading = false;
      }, 1500)
    },
    handleStart() {
      this.loading = true;
      this.called = true;
      // 显示接受和拒绝按钮
      this.beCalled = true;
      this.endCall = false;
      this.cancelCall = false;
      this.fromUserInfo = `${this.toUserId}请求通话`;
      this.playAudio('calling');
    },
    // B 收到offer，发送answer
    async handleOffer(sdp) {

      if (!this.localStream) {
        this.localStream = await this.getUserMedia();
      }
      // 创建PeerConnection
      this.createPeerConnection();

      // 添加本地流
      this.addLocalStream();

      // 设置远程描述
      await this.peerConnection.setRemoteDescription(
        new RTCSessionDescription({
          type: 'offer',
          sdp: sdp
        })
      );

      // 创建并发送answer
      const answer = await this.peerConnection.createAnswer();
      await this.peerConnection.setLocalDescription(answer);

      // webrtc 发起answer
      let data = JSON.stringify({
        cmd: 66,
        appName: "voice",
        roomId: 1001,
        msgType: "answer",
        msgData: answer.sdp,
        fromUserId: this.userId,
        toUserId: this.toUserId
      });
      this.sendMsg(data);
    },
    handleCancel() {
      this.caller = false;
      this.called = false;
      this.endCall = false;

      this.fromUserInfo = "对方取消通话";
      this.playAudio('cancel');
      // 取消传输音频
      this.endPeerCall();
      setTimeout(() => {
        this.loading = false;
      }, 1500)
    },

    handleIceCandidate(candidate) {
      candidate = JSON.parse(candidate);
      if (this.peerConnection && candidate) {
        this.peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
      }
    },
    async getUserMedia() {
      return new Promise((resolve, reject) => {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          // 获取媒体流（音频）
          navigator.mediaDevices.getUserMedia({
            audio: true
          })
            .then(stream => {
              // 不检查 stream.active，而是检查实际轨道状态
              const audioTracks = stream.getAudioTracks();

              if (audioTracks.length === 0) {
                throw new Error('未获取到音频轨道');
              }

              // 检查轨道是否可用
              const validTracks = audioTracks.filter(track => {
                return track.readyState === 'live' && track.enabled;
              });

              if (validTracks.length === 0) {
                throw new Error('没有可用的活跃音频轨道');
              }

              console.log('成功获取音频流，轨道状态:', {
                id: stream.id,
                trackStates: audioTracks.map(t => ({
                  id: t.id,
                  kind: t.kind,
                  readyState: t.readyState,
                  enabled: t.enabled,
                  muted: t.muted
                }))
              });
              // 使用流进行通信
              resolve(stream);
            })
            .catch(error => {
              console.log(error)
              reject(new Error('获取麦克风权限失败'));
            });
        } else {
          console.log('浏览器不支持 getUserMedia');
          reject(new Error('浏览器不支持 getUserMedia'));
        }
      });
    },
    createPeerConnection() {
      this.peerConnection = new RTCPeerConnection(this.configuration);

      this.peerConnection.onicecandidate = (event) => {
        if (event.candidate) {
          let data = JSON.stringify({
            cmd: 66,
            appName: "voice",
            roomId: 1001,
            msgType: "candidate",
            msgData: event.candidate,
            fromUserId: this.userId,
            toUserId: this.toUserId
          });
          this.sendMsg(data);
        }
      };

      this.peerConnection.ontrack = (event) => {
        // video同理
        this.$refs.audioElement.srcObject = event.streams[0];
      };

      this.peerConnection.oniceconnectionstatechange = () => {
        if (this.peerConnection.iceConnectionState === 'disconnected') {
          this.endPeerCall();
        }
      };
    },

    addLocalStream() {
      this.localStream.getTracks().forEach(track => {
        this.peerConnection.addTrack(track, this.localStream);
      });

      // 设置音频处理
      this.setupAudioProcessingNew();
    },
    setupAudioProcessing() {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const sampleRate = this.audioContext.sampleRate; // 可能是 44100 或 48000
      console.log("前端采样率:", sampleRate); // 44100
      const source = this.audioContext.createMediaStreamSource(this.localStream);
      this.processor = this.audioContext.createScriptProcessor(8192, 1, 1);

      this.processor.onaudioprocess = (e) => {
        const audioData = this.processAudio(e.inputBuffer);
        // Array.from(audioData)
        this.sendMsg(audioData.buffer);
      };

      source.connect(this.processor);
      this.processor.connect(this.audioContext.destination);
    },

    processAudio(inputBuffer) {
      const data = inputBuffer.getChannelData(0); // Float32Array(8192)
      const pcm = new Int16Array(data.length);
      for (let i = 0; i < data.length; i++) {
        // pcm[i] = data[i] * 32767; // 转换为16位有符号整数
        pcm[i] = Math.max(-32768, Math.min(32767, data[i] * 32768));
      }
      return pcm;
    },
    async setupAudioProcessingNew() {
      if (!this.audioContext) {
        await this.setupAudioWorklet();
      }

      const source = this.audioContext.createMediaStreamSource(this.localStream);

      // 连接处理链
      source.connect(this.workletNode);
      this.workletNode.connect(this.audioContext.destination);
    },
    async setupAudioWorklet() {
      try {
        this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

        let bypass = `
        // 全局缓冲区和计数器
        let buffer = new Float32Array(8192); // 目标大小
        let bufferIndex = 0;

        // AudioWorkletProcessor 中处理数据
        class AudioRecorderProcessor extends AudioWorkletProcessor {
          process(inputs) {
            const inputData = inputs[0][0]; // 获取输入的 Float32Array(128)
            
            // 将数据填充到缓冲区
            for (let i = 0; i < inputData.length; i++) {
              buffer[bufferIndex++] = inputData[i];
              
              // 缓冲区已满（8192样本），发送数据并重置
              if (bufferIndex === 8192) {
                this.port.postMessage({ // 发送 ArrayBuffer
                  type: 'audioData',
                  data: buffer
                });
                buffer = new Float32Array(8192);     // 新建缓冲区
                bufferIndex = 0;
              }
            }
            
            return true;
          }
        }
        registerProcessor('audioProcessor', AudioRecorderProcessor);
        `;
        let blob = new Blob([bypass], { type: 'application/javascript' });
        // 1. 加载并添加AudioWorklet处理器
        await this.audioContext.audioWorklet.addModule(URL.createObjectURL(blob));
        // const bypasser = new AudioWorkletNode(this.audioContext, 'bypass');

        // 2. 创建Worklet节点
        this.workletNode = new AudioWorkletNode(
          this.audioContext,
          'audioProcessor'
        );
        // 3. 设置消息处理器
        this.workletNode.port.onmessage = (event) => {
          if (event.data.type === 'audioData') {
            // TODO 音频数据
            this.handleAudioData(event.data.data);
          }
        };
      } catch (error) {
        console.error('AudioWorklet setup failed:', error);
      }

    },
    handleAudioData(audioData) {
      // 处理音频数据（发送到服务器等）
      const pcmData = new Int16Array(audioData.length);
      for (let i = 0; i < audioData.length; i++) {
        pcmData[i] = Math.max(-32768, Math.min(32767, audioData[i] * 32768));
      }
      if (this.websocket.readyState === WebSocket.OPEN) {
        this.sendMsg(pcmData.buffer);
      }
    },
    async createAndSendOffer() {
      const offer = await this.peerConnection.createOffer();
      await this.peerConnection.setLocalDescription(offer);

      // webrtc 发起offer
      let data = JSON.stringify({
        cmd: 66,
        appName: "voice",
        roomId: 1001,
        msgType: "offer",
        msgData: offer.sdp,
        fromUserId: this.userId,
        toUserId: this.toUserId
      });
      this.sendMsg(data);
    },
    endPeerCall() {

      // 关闭连接
      if (this.peerConnection) {
        this.peerConnection.close();
        this.peerConnection = null;
      }

      if (this.localStream) {
        this.localStream.getTracks().forEach(track => track.stop());
        this.localStream = null;
      }

      if (this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
      }
    },
    playChatAudio(arrayBuffer) {
      if (!this.audioContext) return;
      const audioData = new Float32Array(arrayBuffer.byteLength / 2);

      if (!audioData || audioData.length === 0) {
        // console.error('音频数据为空或长度为0');
        return;
      }

      const int16Array = new Int16Array(arrayBuffer);

      for (let i = 0; i < int16Array.length; i++) {
        audioData[i] = int16Array[i] / 32767.0; // 转换为浮点
      }

      const audioBuffer = this.audioContext.createBuffer(1, audioData.length, 44100);
      audioBuffer.getChannelData(0).set(audioData);

      const source = this.audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(this.audioContext.destination);
      source.start();
    },
  }
}
</script>
<style scoped>
.content {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.layout {
  width: 100%;
  height: 100%;
  position: relative;
}

.van-popup--center {
  max-width: 100% !important;
}

.user_box {
  width: 300rpx;
  height: 300rpx;
  position: absolute;
  top: 200rpx;
  left: 50%;
  transform: translateX(-50%);
}

.user {
  width: 300rpx;
  height: 100rpx;
  line-height: 100rpx;
  text-align: center;
  border-radius: 30rpx;
  margin-bottom: 30rpx;
  background-color: #888888;
}

.show_user {
  width: 500rpx;
  height: 100rpx;
  line-height: 100rpx;
  text-align: center;
  font-size: 32rpx;
  color: #111111;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.btn_box {
  width: 500rpx;
  height: 100rpx;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100rpx;
}

.btn_caller {
  width: 200rpx;
  height: 100rpx;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}

.btn_call {
  width: 200rpx;
  height: 100rpx;
  line-height: 100rpx;
  text-align: center;
  border-radius: 30rpx;
  background-color: #00ffff;
  position: absolute;
  left: 0;
  top: 0;
}

.btn_cancel {
  width: 200rpx;
  height: 100rpx;
  line-height: 100rpx;
  text-align: center;
  border-radius: 30rpx;
  background-color: #ff0000;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100rpx;
}

.btn_called {
  width: 500rpx;
  height: 100rpx;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 100rpx;
}

.btn_reject {
  width: 200rpx;
  height: 100rpx;
  line-height: 100rpx;
  text-align: center;
  border-radius: 30rpx;
  background-color: #ff0000;
  position: absolute;
  left: 0;
  top: 0;
}

.btn_accept {
  width: 200rpx;
  height: 100rpx;
  line-height: 100rpx;
  text-align: center;
  border-radius: 30rpx;
  background-color: #00ffff;
  position: absolute;
  right: 0;
  top: 0;
}

.infer_box {
  width: 100vw;
  /* height: 100%; */
  height: 100vh;
  position: absolute;
  top: 0;
}

.loading_box {
  width: 500rpx;
  height: 500rpx;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.from_user {
  width: 100%;
  height: 60rpx;
  text-align: center;
  line-height: 60rpx;
  color: #111111;
  font-size: 32rpx;
  position: absolute;
  top: 50%;
}

.times_box {
  width: 100%;
  height: 60rpx;
  text-align: center;
  line-height: 60rpx;
  color: #333333;
  font-size: 32rpx;
  position: absolute;
  top: 60%;
}

.loading_item {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 250rpx;
  position: absolute;
  transform-origin: 50% 53%;
}

.loading1 {
  border: 12px solid #ff0000;
  animation: rotate 9s infinite linear;
}

.loading2 {
  border: 12px solid #ff7f00;
  animation: rotate 9s infinite -1s linear;
}

.loading3 {
  border: 12px solid #ffff00;
  animation: rotate 9s infinite -2s linear;
}

.loading4 {
  border: 12px solid #00ff00;
  animation: rotate 9s infinite -3s linear;
}

.loading5 {
  border: 12px solid #00ffff;
  animation: rotate 9s infinite -4s linear;
}

.loading6 {
  border: 12px solid #0000ff;
  animation: rotate 9s infinite -5s linear;
}

.loading7 {
  border: 12px solid #8b00ff;
  animation: rotate 9s infinite -6s linear;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
